import { render, staticRenderFns } from "./BackCode.vue?vue&type=template&id=0b29f80e"
import script from "./BackCode.vue?vue&type=script&lang=js"
export * from "./BackCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports